export class ActionDateQueryModel {
    public fromDate: string;
    public toDate: string;
    public operator: number;
}
